import { getFee } from 'lib/firebase/utils';
import Table from 'components/shared/table';
import getFormattedStatus from 'lib/utils/getFormattedStatus';
import getFormattedDate from 'lib/utils/getFormattedDate';
import { formatPriceByStoreLocale } from 'lib/shopify';
import { getExpirationDate } from 'lib/utils/helpers';

const Orders = ({ salon, global, locale }) => {
  const ORDERS_TABLE = {
    title: global.orders['ordersTable-Title']?.text,
    description: null,
    linktext: null,
    action: null,
    infotext: null,
    columns: [
      {
        label: 'Kickbackfee',
        icon: null,
        id: 'kickbackfee',
      },
      {
        label: global.tables['tables-Total']?.text,
        icon: null,
        id: 'orderTotal',
      },
      {
        label: global.tables['tables-Date']?.text,
        icon: null,
        id: 'date',
      },
      {
        label: global.tables['tables-ExpirationDate']?.text,
        icon: null,
        id: 'expirationDate',
      },
      {
        label: 'Status',
        icon: null,
        id: 'status',
      },
    ],
    rows: salon.orders
      .map(({ amount, status, date, orderNo, handleCost }) => ({
        kickbackfee: formatPriceByStoreLocale({
          locale,
          price: getFee(amount, salon.salonKickbackfeeMargin, handleCost),
        }),
        amount: formatPriceByStoreLocale({
          locale,
          price: getFee(amount, salon.salonKickbackfeeMargin, handleCost),
        }),
        date: getFormattedDate(date, 'ISO'),
        expirationDate: getFormattedDate(getExpirationDate(date), 'ISO'),

        status: getFormattedStatus(
          status,
          global?.orders['ordersTable-Paid']?.text,
          global?.orders['ordersTable-Payable']?.text,
          global?.orders['ordersTable-AwaitingReturnPeriod']?.text,
          global?.orders['ordersTable-Expired']?.text
        ),
        orderNo,
      }))
      // eslint-disable-next-line
      .sort((a, b) => new Date(a.date) - new Date(b.date)),
  };

  return (
    <div>
      <Table salon={salon} table={ORDERS_TABLE} hasActions global={global} />
    </div>
  );
};

export default Orders;
